/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdatePoolMiningCommissionItem } from './update-pool-mining-commission-item';


export interface UpdatePoolMiningCommissionsRequest { 
    items: Array<UpdatePoolMiningCommissionItem>;
    verificationCode: string;
}

